import api from './api'

export const globalTaskService = {
  getMyTasks: async () => {
    const response = await api.get('/tasks/my-tasks')
    return response.data
  },

  searchTasks: async (query) => {
    const response = await api.get('/tasks/search', { params: { q: query } })
    return response.data
  },

  getTimeSummary: async () => {
    const response = await api.get('/time-entries/my-summary')
    return response.data
  },

  getTeamMembers: async () => {
    const response = await api.get('/users/team-members')
    return response.data
  },
}
